import { FC } from 'react';

import { GiftCsMemoTarget } from '@shared/api/giftCsMemo/giftCsMemo.interface';
import { CsMemoButtonBase, CsMemoButtonBaseProps } from '@shared/components/csMemo';

import { GIFT_CS_MEMO_EMPTY_TARGET, giftCsMemoAdapter } from './giftCsMemoAdapter';

export type CsMemoButtonProps = Omit<
  CsMemoButtonBaseProps<GiftCsMemoTarget>,
  'adapter' | 'emptyTarget'
>;

/** 답례품 CS 메모 진입 배지 — 공용 버튼에 gift 어댑터를 물려둔 것 */
export const CsMemoButton: FC<CsMemoButtonProps> = (props) => (
  <CsMemoButtonBase
    {...props}
    adapter={giftCsMemoAdapter}
    emptyTarget={GIFT_CS_MEMO_EMPTY_TARGET}
  />
);
